import { StyledMusicIcon } from './styled';

export const MusicIconSVG = (): JSX.Element => {
  return (
    <StyledMusicIcon
      className="musicIcon"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" clipPath="url(#clip0_1524_437)">
        <path
          d="M3.91939 1.94191V8.3296C3.5477 7.99803 3.0579 7.79616 2.52177 7.79616C1.36279 7.79616 0.419876 8.73908 0.419876 9.89808C0.419876 11.0571 1.36279 12 2.52177 12C3.67932 12 4.62125 11.0595 4.62364 9.90247H4.62369V4.76894L10.8758 3.18407V6.63395C10.5041 6.30238 10.0143 6.10051 9.47819 6.10051C8.31919 6.10051 7.37628 7.04342 7.37628 8.20241C7.37628 9.36141 8.31919 10.3043 9.47819 10.3043C10.6372 10.3043 11.5801 9.36139 11.5801 8.20241V0L3.91939 1.94191Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1524_437">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </StyledMusicIcon>
  );
};
